// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Part } from './part';
import { PartConfigAttachment } from './part-config-attachment';
import { PartConfigurationLine } from './part-configuration-line';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartConfiguration extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  deleted?: Date;
  description?: string;
  partId?: number;
  partNumber?: string;
  processed?: Date;
  attachments!: PartConfigAttachment[];
  lines!: PartConfigurationLine[];
  part!: Part;
}

